<template>
  <div class="work-log-detail" v-loading="loading">
    <WelcomeBanner :title="log.action || '工作日志详情'">
      <div slot="right">
        <el-button type="text" icon="el-icon-arrow-left" size="small" class="back-button" @click="goBack">返回</el-button>
        <el-tag :type="getStatusType(log.status)" effect="dark" size="medium">
          {{ getStatusText(log.status) }}
        </el-tag>
      </div>
    </WelcomeBanner>

    <BaseCard>
      <!-- 基本信息卡片 -->
      <el-card v-if="log.log_id" class="info-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-info"></i> 基本信息</span>
      </div>
      <div class="basic-info">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">日志ID：</span>
            <span class="value">{{ log.log_id }}</span>
          </div>
          <div class="info-item">
            <span class="label">执行机器人：</span>
            <span class="value">{{ log.robot_id }}</span>
          </div>
          <div class="info-item">
            <span class="label">所属项目：</span>
            <span class="value">{{ log.project_id || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">执行时间：</span>
            <span class="value">{{ formatTime(log.create_time) }}</span>
          </div>
          <div class="info-item">
            <span class="label">执行耗时：</span>
            <span class="value">{{ log.cost_ms ? formatDuration(log.cost_ms) : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">执行动作：</span>
            <span class="value action-desc">{{ log.action_desc || '-' }}</span>
          </div>
        </div>
      </div>
      </el-card>

      <!-- 执行动作 -->
      <el-card class="content-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-s-operation"></i> 执行动作</span>
      </div>
      <div class="markdown-content">{{ log.action || '无执行动作记录' }}</div>
      </el-card>

      <!-- 响应数据 -->

    <!-- 执行结果摘要 -->
    <el-card v-if="log.result_summary" class="content-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-document"></i> 执行结果</span>
      </div>
      <div class="result-content">{{ log.result_summary }}</div>
      </el-card>

      <!-- 错误信息 -->

    <!-- 响应数据 -->
    <el-card v-if="log.response_data" class="content-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-data-line"></i> 响应数据</span>
      </div>
      <pre class="response-data">{{ formatJson(log.response_data) }}</pre>
    </el-card>

    <!-- 错误信息 -->
    <el-card v-if="log.error_message" class="content-card error-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-warning"></i> 错误信息</span>
      </div>
      <div class="error-message">{{ log.error_message }}</div>
      </el-card>
    </BaseCard>
  </div>
</template>

<script>
import { getWorkLogDetail } from '../api/workLog'
import BaseCard from '@/components/BaseCard'
import WelcomeBanner from '@/components/WelcomeBanner'

export default {
  name: 'WorkLogDetail',
  components: { BaseCard, WelcomeBanner },
  data() {
    return {
      logId: null,
      log: {},
      loading: false
    }
  },
  created() {
    this.logId = this.$route.params.id
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        // 响应拦截器已返回 res.data，直接使用
        const data = await getWorkLogDetail(this.logId)
        if (data) {
          this.log = data
        } else {
          this.$message.error('获取数据失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      return new Date(timestamp).toLocaleString('zh-CN')
    },
    getStatusType(status) {
      const map = { 1: 'warning', 2: 'success', 3: 'danger' }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = { 1: '执行中', 2: '成功', 3: '失败' }
      return map[status] || '未知'
    },
    // 返回上一页
    goBack() {
      this.$router.back()
    },
    // 格式化耗时
    formatDuration(ms) {
      if (ms < 1000) {
        return `${ms}毫秒`
      } else if (ms < 60000) {
        return `${(ms / 1000).toFixed(1)}秒`
      } else {
        const minutes = Math.floor(ms / 60000)
        const seconds = ((ms % 60000) / 1000).toFixed(0)
        return `${minutes}分${seconds}秒`
      }
    },
    // 格式化JSON
    formatJson(data) {
      try {
        if (typeof data === 'string') {
          const parsed = JSON.parse(data)
          return JSON.stringify(parsed, null, 2)
        }
        return JSON.stringify(data, null, 2)
      } catch (e) {
        return data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.work-log-detail {
  padding: 20px;
  background-color: var(--bg-page);
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
  }
}

/* 卡片样式 */
.info-card,
.content-card {
  margin-bottom: 20px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.card-header {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);

  i {
    margin-right: 8px;
  }
}

/* 基本信息网格 */
.basic-info {
  padding: 10px 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;

  .label {
    font-weight: 600;
    color: var(--text-secondary);
    white-space: nowrap;
    min-width: 90px;
  }

  .value {
    color: var(--text-primary);
    flex: 1;

    &.action-desc {
      color: var(--primary-color);
      font-weight: 500;
    }
  }
}

/* 内容卡片 */
.markdown-content,
.result-content {
  line-height: 1.8;
  white-space: pre-wrap;
  color: var(--text-secondary);
  padding: 10px 0;
}

.response-data {
  background-color: var(--bg-page);
  padding: 16px;
  border-radius: var(--radius-md);
  overflow-x: auto;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-primary);
  border: 1px solid var(--border-light);
}

/* 错误卡片 */
.error-card {
  ::v-deep .el-card__header {
    background-color: var(--danger-light, #fef0f0);
    color: var(--danger-color, #f56c6c);
  }
}

.error-message {
  color: var(--danger-color, #f56c6c);
  padding: 12px;
  background-color: var(--danger-light, #fef0f0);
  border-radius: var(--radius-md);
  line-height: 1.6;
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;

    .header-left {
      flex-direction: column;
      gap: 12px;
    }
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .info-item {
    flex-direction: column;
    gap: 4px;

    .label {
      min-width: auto;
    }
  }
}
</style>
